document.addEventListener('click', (event) => {
  const revealButton = event.target.closest('[data-reveal-target]');
  const finishButton = event.target.closest('[data-finish-step]');

  if (revealButton || finishButton) {
    const button = revealButton || finishButton;

    if (revealButton) {
      const targetFieldset = document.getElementById(revealButton.dataset.revealTarget);
      const targetBody = targetFieldset?.querySelector('.product-option-box__body, .filling-picker__options');
      if (targetBody) targetBody.classList.remove('step-body-collapsed');
    }

    const body = button.closest('.product-option-box__body, .filling-picker__options');
    if (body) body.classList.add('step-body-collapsed');
    return;
  }

  const heading = event.target.closest('.product-option-box__heading, .filling-picker__heading');
  if (!heading) return;

  const box = heading.closest('.product-option-box, .filling-picker__box');
  const body = box?.querySelector('.product-option-box__body, .filling-picker__options');
  if (body) body.classList.toggle('step-body-collapsed');
});
